import App from './App.svelte';

const app = new App({
  // The #project-browser markup is returned by the fortra_tools.tool Drupal route.
  target: document.querySelector('#tool-block'),
  props: {},
});

export default app;
